import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

// Trailing slash causes problem in Links so remove.
// e.g. <Link to={`${match.url}/foo`} /> will result in
//      example.com/bar//foo
const RemoveTrailingSlash = ({location}) => {
  const {pathname} = location;

  if (pathname.substr(-1) === '/') {
    return <Redirect to={pathname.substr(0, pathname.length - 1)} />;
  } else {
    return null;
  }
};

RemoveTrailingSlash.propTypes = {
  location: PropTypes.object,
};

export default RemoveTrailingSlash;



// WEBPACK FOOTER //
// ./src/components/util/RemoveTrailingSlash.js